import { jsx as _jsx } from "react/jsx-runtime";
import { Link as ThLink } from '@drdropin-tech/theseus';
import NextLink from 'next/link';
export default function Link({ as = 'link', buttonProps, to = '', rel = 'norefferer', className, children, disabled, isExternalLink, locale = 'nb', }) {
    if (disabled) {
        return _jsx("div", { className: `${className} pointer-events-none`, children: children });
    }
    const isOutsideOfNext = to?.includes('https') || isExternalLink;
    if (isOutsideOfNext) {
        return (_jsx(ThLink, { href: to, as: as, title: `Link to: ${to}`, className: className, target: "_blank", rel: rel, children: children }));
    }
    const localizedPrefix = locale === 'nb' ? '' : '/en';
    const href = `${localizedPrefix}${to}`;
    const btnProps = as === 'button' ? buttonProps : {};
    return (_jsx(NextLink, { passHref: true, href: href, locale: locale, children: _jsx(ThLink, { as: as, className: className, ...btnProps, children: children }) }));
}
